import { render, staticRenderFns } from "./collectionPop.vue?vue&type=template&id=1d5c1d68&scoped=true"
import script from "./collectionPop.vue?vue&type=script&lang=js"
export * from "./collectionPop.vue?vue&type=script&lang=js"
import style0 from "./collectionPop.vue?vue&type=style&index=0&id=1d5c1d68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c1d68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5c1d68')) {
      api.createRecord('1d5c1d68', component.options)
    } else {
      api.reload('1d5c1d68', component.options)
    }
    module.hot.accept("./collectionPop.vue?vue&type=template&id=1d5c1d68&scoped=true", function () {
      api.rerender('1d5c1d68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/components/collectionPop.vue"
export default component.exports